import * as urlUtil from '@core/js/utils/url.util';

const addLangToPath = (path, pathLang) => {
    const { cleanUrl, lang } = urlUtil.parseUrl(path);
    const selectedPathLang = pathLang ? `/${pathLang}` : '';

    if (lang) {
        return path[0] === '/' ? path : `/${path}`;
    }

    return `${selectedPathLang}${cleanUrl}`;
};

const getCombinedSearch = (pathOrLocation, currentSearch, removeParams, currentHash) => {
    if (typeof pathOrLocation === 'string') {
        const [path, search] = pathOrLocation.split('?');
        const combinedSearch = urlUtil.getCombinedSearch(search, currentSearch, removeParams);

        return `${path}${combinedSearch}${currentHash}`;
    }

    return {
        ...pathOrLocation,
        search: urlUtil.getCombinedSearch(pathOrLocation.search, currentSearch, removeParams),
        hash: currentHash
    };
};

export const formatPath = (url, pathLang, currentSearch, currentHash, removeParams, useTrailingSlash) => {
    const [, , , targetPath, targetSearch = '', targetHash = ''] = urlUtil.getPartsUrl(url);
    const pathWithLang = addLangToPath(targetPath, pathLang);
    const pathWithTrailingSlash = urlUtil.getPathWithTrailingSlash(pathWithLang, useTrailingSlash);
    const pathWithSearch = `${pathWithTrailingSlash}${targetSearch}`;

    return getCombinedSearch(pathWithSearch, currentSearch, removeParams, targetHash || currentHash);
};

export const getStateWithPrevPath = (pathOrLocation, state) => {
    /* TotalCasino changes */
    if (pathOrLocation?.state) {
        pathOrLocation.state.prevPath = pathOrLocation?.state?.prevPath || urlUtil.getCleanUrl();

        return state;
    }
    /* TotalCasino changes */

    return {
        prevPath: urlUtil.getCleanUrl(),
        ...state
    };
};
